import { router } from '@inertiajs/vue3';
import { ref } from 'vue';

export default function usePagination(resource = {}, relation = null) {
  const currentPage = ref(resource.meta?.adjustments.pagination.page ?? {});
  const links = ref(resource.links ?? {});
  const page = ref(resource.page ?? {}); // ?
  const perPage = ref(resource.meta?.adjustments.pagination.perPage ?? 10);

  const updatePerPage = (event, route, routePrefix) => {
    let url = route(`${routePrefix}.${resource.meta.resourceType}.adjust`);
    let searchParams = { perPage: event.target.value };
    if (relation) {
      searchParams['relation'] = relation;
    }
    router.get(url, searchParams, {
      // preserveState: true,
      // only: ['models'],
      replace: true,
    });
  };

  return {
    currentPage,
    links,
    page,
    perPage,
    updatePerPage,
  };
}
